firebird.factory('avDeviceService', [
    '$rootScope',
    '$window',
    '$q',
    '$sce',
    '$interval',
    '$timeout',
    'logService',
    'storageService',
    'helperService',
    'localStreamManagerService',
    'socketService',
    'supportLinkService',
    'meetingService',
    'localizationService',
    'brandingService',
    'attendeeService',
    'connectivityService',
    'growlService',
    'executionEnvironmentEnum',
    'notificationService',
    'macSecurityPreferencesService',
    function (
        $rootScope,
        $window,
        $q,
        $sce,
        $interval,
        $timeout,
        logService,
        storageService,
        helperService,
        localStreamManagerService,
        socketService,
        supportLinkService,
        meetingService,
        localizationService,
        brandingService,
        attendeeService,
        connectivityService,
        growlService,
        executionEnvironmentEnum,
        notificationService,
        macSecurityPreferencesService
    ) {
        const logger = new LogServiceWrapper(logService, 'avDeviceService');

        var devicesAvailable = {
            microphone: false,
            webcam: false
        };

        var devicePermissions = {
            audioAllowed: false,
            videoAllowed: false
        };

        var macOSSystemPermissions = {
            audioAllowed: false,
            videoAllowed: false
        };

        var deviceErrors = {
            camError: false,
            micError: false,
            micAdditional: '',
            camAdditional: ''
        };

        //New Device Error handling logic...
        //leaving original "deviceErrors" alone for webinar compatibility
        var sfuDeviceErrors = {};

        var ignoreCamera = false;

        var devicePermissionPromptTimeout = null;

        var pendingDeviceReconnect = false;

        var isPermissionOverlayOpen = false;

        var microphoneDeviceSwitching = false;

        var audioDisconnected = false;

        var micSystemDeviceObj = null;

        let newVideoDeviceConnected = false; // the only webcam was plugged in during the meeting

        var service = {
            microphones: [],
            speakers: [],
            webcams: [],

            defaultAudioInputObj: null,
            defaultAudioOutputObj: null,

            ignoredDevices: {
                microphones: {
                    communications: null,
                    default: null
                },
                webcams: {
                    communications: null,
                    default: null
                },
                speakers: {
                    communications: null,
                    default: null
                }
            },

            audioContext: null,
            micLevelIntervals: [],

            deviceTypes: {
                AUDIO_INPUT: 1,
                AUDIO_OUTPUT: 2,
                VIDEO_INPUT: 3
            },

            enumerateDevices: enumerateDevices,
            clearDevices: clearDevices,
            getStream: getStream,
            generateConstraints: generateConstraints,
            generateDeviceObj: generateDeviceObj,
            getIndexOfDeviceWithMatchingLabel: getIndexOfDeviceWithMatchingLabel,
            isDeviceInUse: isDeviceInUse,
            addDeviceToArray: addDeviceToArray,
            checkIfDeviceIsAvailable: checkIfDeviceIsAvailable,
            getCurrentlySelectedMic: getCurrentlySelectedMic,
            getCurrentlySelectedWebcam: getCurrentlySelectedWebcam,
            checkForBTHeadset: checkForBTHeadset,

            //Mic Level Tracking
            openAudioContext: openAudioContext,
            closeAudioContext: closeAudioContext,
            isAudioTrackActive: isAudioTrackActive,
            createAudioAnalyser: createAudioAnalyser,
            getAverageAudioVolume: getAverageAudioVolume,
            trackMicLevelForPreview: trackMicLevelForPreview,
            trackMicLevel: trackMicLevel,
            stopMicLevelTrackingForPreview: stopMicLevelTrackingForPreview,
            canTrackStartStopTalking: canTrackStartStopTalking,
            trackStartStopTalking: trackStartStopTalking,
            cancelNotTalkingTimeout: cancelNotTalkingTimeout,
            untrackStartStopTalking: untrackStartStopTalking,
            getAudioOutputTestSource: getAudioOutputTestSource,

            //Device Availability & Permissions
            setHasMicrophone: setHasMicrophone,
            setHasCamera: setHasCamera,
            hasMicrophone: hasMicrophone,
            hasCamera: hasCamera,
            getDevicePermissions: getDevicePermissions,
            setDevicePermissions: setDevicePermissions,
            sendDevicePermissions: sendDevicePermissions,
            getDeviceErrors: getDeviceErrors,
            setDeviceErrors: setDeviceErrors,
            setShouldIgnoreCamera: setShouldIgnoreCamera,
            shouldIgnoreCamera: shouldIgnoreCamera,
            getActiveDevices: getActiveDevices,

            hasMicrophoneDeviceError: hasMicrophoneDeviceError,
            isMicrophoneHavingAnIssue: isMicrophoneHavingAnIssue,

            isAudioDeviceBlocked: isAudioDeviceBlocked,
            isVideoDeviceBlocked: isVideoDeviceBlocked,

            isWebcamHavingAnIssue: isWebcamHavingAnIssue,
            hasWebcamDeviceError: hasWebcamDeviceError,

            getIsMicrophoneDeviceSwitching: getIsMicrophoneDeviceSwitching,
            setIsMicrophoneDeviceSwitching: setIsMicrophoneDeviceSwitching,

            getIsNewVideoDeviceConnected: getIsNewVideoDeviceConnected,
            setIsNewVideoDeviceConnected: setIsNewVideoDeviceConnected,

            checkIfAVDevicePermissionsGranted: checkIfAVDevicePermissionsGranted,
            showBlockedPermissionsBanner: showBlockedPermissionsBanner,
            showBlockedAlert: showBlockedAlert,
            determineMicAndCamAvailability: determineMicAndCamAvailability,
            showDevicePermissionPromptWithDelay: showDevicePermissionPromptWithDelay,
            cancelDevicePermissionPrompt: cancelDevicePermissionPrompt,

            initDeviceChangeListener: initDeviceChangeListener,
            removeDeviceChangeListener: removeDeviceChangeListener,
            onDeviceChange: onDeviceChange,
            promptForExplicitlyChosenDevices: promptForExplicitlyChosenDevices,
            setIsPendingDeviceReconnect: setIsPendingDeviceReconnect,
            getIsPendingDeviceReconnect: getIsPendingDeviceReconnect,
            requestSystemPermissionForDevices: requestSystemPermissionForDevices,
            getMacOSSystemPermissions: getMacOSSystemPermissions,

            //New Device Error logic - For SFU (Non-Webinar)
            setSfuDeviceError: setSfuDeviceError,
            clearSfuDeviceError: clearSfuDeviceError,
            getSfuDeviceErrorFromId: getSfuDeviceErrorFromId,
            getSfuDeviceErrors: getSfuDeviceErrors,

            startDevicePermissionsFlow: startDevicePermissionsFlow,
            audioOrVideoBlocked: audioOrVideoBlocked,
            startWebrtcPromptOverlay: startWebrtcPromptOverlay,

            //platform specific functions
            openMicCamPermissionTroubleShootPage: openMicCamPermissionTroubleShootPage,
            openMicCamPermissionTroubleShootPageForElectron: openMicCamPermissionTroubleShootPageForElectron,
            openMicrophoneSystemPreference: openMicrophoneSystemPreference,
            openCameraSystemPreference: openCameraSystemPreference,

            setIsPermissionOverlayOpen: setIsPermissionOverlayOpen,
            getIsPermissionOverlayOpen: getIsPermissionOverlayOpen,

            isAudioDisconnected: isAudioDisconnected,
            toggleMuteAudioInputAndOutput: toggleMuteAudioInputAndOutput,
            setAudioDisconnected: setAudioDisconnected,
            handleDetachedDeviceTrackOnVDI: handleDetachedDeviceTrackOnVDI,
            switchToSelectedAudioInputOnVdi: switchToSelectedAudioInputOnVdi,

            getAllPhysicalMicDevices: getAllPhysicalMicDevices
        };

        return service;

        ////////////////////////

        function enumerateDevices() {
            var deferred = $q.defer();

            if (
                $window.navigator &&
                $window.navigator.mediaDevices &&
                $window.navigator.mediaDevices.enumerateDevices
            ) {
                logService.log('Attempting to enumerate devices');

                $window.navigator.mediaDevices
                    .enumerateDevices()
                    .then(function (devices) {
                        logService.log('Successfully enumerated devices:', devices);

                        //Clear device lists before populating them with updated devices
                        service.clearDevices();

                        var allowedMic = false;
                        var allowedCam = false;

                        devices.forEach(function (device, index, array) {
                            if (device.label.includes('(Virtual)')) {
                                return;
                            }
                            switch (device.kind) {
                                case 'audioinput':
                                    service.addDeviceToArray(device, service.microphones);
                                    break;
                                case 'audiooutput':
                                    service.addDeviceToArray(device, service.speakers);
                                    break;
                                case 'videoinput':
                                    service.addDeviceToArray(device, service.webcams);
                                    if (helperService.getDevicePlatform() === 'iOS' && device.label === 'Back Camera') {
                                        logService.log('Skipping Back Camera...');
                                        break;
                                    }
                                    break;
                                default:
                                    logger.error('enumerateDevices', 'Unhandled device type', device);
                                    break;
                            }
                        });

                        //Device Selection Preview will run its own BT Headset filtering
                        if (!meetingService.shouldShowDeviceSelectionPreview()) {
                            try {
                                service.checkForBTHeadset();
                            } catch (e) {
                                logger.error('enumerateDevices', 'Error checking for BT headset and headphones', e);
                            }
                        }

                        devicesAvailable.microphone = service.microphones.length > 0;
                        devicesAvailable.webcam = service.webcams.length > 0;

                        deferred.resolve();
                    })
                    .catch(function (err) {
                        logService.log('Error enumerating devices');
                        deferred.reject(err);
                    });
            } else {
                deferred.reject('enumerateDevices not available');
            }

            return deferred.promise;
        }

        function clearDevices() {
            service.microphones = [];
            service.speakers = [];
            service.webcams = [];

            service.ignoredDevices.microphones.communications = null;
            service.ignoredDevices.microphones.default = null;

            service.ignoredDevices.webcams.communications = null;
            service.ignoredDevices.webcams.default = null;

            service.ignoredDevices.speakers.communications = null;
            service.ignoredDevices.speakers.default = null;
        }

        function getStream(constraints, noStream) {
            var deferred = $q.defer();

            if (noStream) {
                //Resolve without attempting to retrieve stream
                deferred.resolve(null);
                return deferred.promise;
            }

            if ($window.navigator && $window.navigator.getUserMedia) {
                var getUserMediaTimeout = $timeout(function () {
                    var deviceId;

                    if (
                        constraints &&
                        constraints.audio &&
                        constraints.audio.mandatory &&
                        constraints.audio.mandatory.sourceId
                    ) {
                        deviceId = constraints.audio.mandatory.sourceId;
                    } else if (
                        constraints &&
                        constraints.video &&
                        constraints.video.mandatory &&
                        constraints.video.mandatory.sourceId
                    ) {
                        deviceId = constraints.video.mandatory.sourceId;
                    }

                    if (deviceId) {
                        logService.log('avDeviceService - getUserMedia timed out for:', deviceId);
                    } else {
                        logService.log('avDeviceService - getUserMedia timed out');
                    }
                }, 3000);

                $window.navigator.getUserMedia(
                    constraints,
                    function (stream) {
                        $timeout.cancel(getUserMediaTimeout);
                        deferred.resolve(stream);
                    },
                    function (err) {
                        $timeout.cancel(getUserMediaTimeout);
                        deferred.reject(err);
                    }
                );
            } else {
                deferred.reject('getUserMedia not available');
            }

            return deferred.promise;
        }

        function generateConstraints(type, srcId, videoType) {
            var constraints = { audio: false, video: false };

            if (type === 'audio') {
                constraints.audio = {
                    deviceId: srcId ? { exact: srcId } : undefined
                };
            }

            if (type === 'video') {
                constraints.video = localStreamManagerService.getIdealVideoConstraints(videoType);
                constraints.video.deviceId = srcId ? { exact: srcId } : undefined;
            }

            return constraints;
        }

        function generateDeviceObj(mediaDeviceInfo, deviceIndex, noStream) {
            var deferred = $q.defer();
            var constraintsMediaType;
            var constraints;
            var defaultLabel;

            //Example Output:
            // {
            //     deviceInfo: {
            //         deviceId: 1234,
            //         kind: 'audioinput',
            //         label: 'Logitech Camera'
            //     },
            //     stream: [mediaStreamObject],
            //     micLevel: '75%',
            //     inUse: true,
            //     recommended: true
            // }

            var deviceObj = {
                deviceInfo: null,
                stream: null,
                micLevel: 0,
                inUse: false,
                recommended: false
            };

            try {
                if (mediaDeviceInfo) {
                    deviceObj.deviceInfo = mediaDeviceInfo;

                    switch (mediaDeviceInfo.kind) {
                        case 'audioinput':
                            defaultLabel = 'Microphone ' + deviceIndex;
                            constraintsMediaType = 'audio';
                            if (service.isDeviceInUse(mediaDeviceInfo)) {
                                deviceObj.inUse = true;
                            }
                            break;
                        case 'audiooutput':
                            defaultLabel = 'Speaker ' + deviceIndex;
                            if (service.isDeviceInUse(mediaDeviceInfo)) {
                                deviceObj.inUse = true;
                            }
                            break;
                        case 'videoinput':
                            defaultLabel = 'Webcam ' + deviceIndex;
                            if (service.isDeviceInUse(mediaDeviceInfo)) {
                                deviceObj.inUse = true;
                            }
                            constraintsMediaType = 'video';
                            break;
                    }

                    if (deviceObj.deviceInfo.label) {
                        if (deviceObj.deviceInfo.label.toLowerCase().indexOf('headset') > -1) {
                            deviceObj.recommended = true;
                        }

                        //Remove gaps of whitespace and include 'recommended' label
                        deviceObj.deviceInfo.sanitizedLabel =
                            deviceObj.deviceInfo.label.replace(/\s+/g, ' ') +
                            (deviceObj.recommended
                                ? ' (' + localizationService.translate('HEADER.TOOLTIP.RECOMMENDED_DEVICE') + ')'
                                : '');
                    } else {
                        //If empty label, provide default
                        deviceObj.deviceInfo.sanitizedLabel = defaultLabel;
                    }

                    if (deviceObj.deviceInfo.deviceId === 'default' && mediaDeviceInfo.kind === 'audioinput') {
                        micSystemDeviceObj = deviceObj;
                    }

                    if (noStream) {
                        //Resolve without attempting to retrieve stream
                        deferred.resolve(deviceObj);
                    } else if (constraintsMediaType) {
                        //Audio Input and Video Input
                        constraints = service.generateConstraints(constraintsMediaType, mediaDeviceInfo.deviceId);

                        service
                            .getStream(constraints)
                            .then(function (stream) {
                                deviceObj.stream = stream;

                                if (constraintsMediaType === 'audio') {
                                    try {
                                        service.trackMicLevelForPreview(stream, function (newMicLevel) {
                                            deviceObj.micLevel = newMicLevel;
                                            if (
                                                micSystemDeviceObj &&
                                                micSystemDeviceObj.deviceInfo.groupId === deviceObj.deviceInfo.groupId
                                            ) {
                                                micSystemDeviceObj.micLevel = newMicLevel;
                                                micSystemDeviceObj.stream = stream;
                                            }
                                        });
                                    } catch (e) {
                                        logger.error('generateDeviceObj', 'error while trackMicLevelForPreview', e);
                                    }
                                } else if (constraintsMediaType === 'video') {
                                    //If we find a valid video stream, we can clear video device error...
                                    //
                                    //This doesn't apply to audio, because user needs to reconnect audio to the Janus call
                                    //before we can clear the audio device error
                                    if (service.getSfuDeviceErrorFromId(mediaDeviceInfo.deviceId)) {
                                        service.clearSfuDeviceError(mediaDeviceInfo.deviceId);
                                    }

                                    if (
                                        stream &&
                                        stream.getVideoTracks &&
                                        stream.getVideoTracks()[0] &&
                                        helperService.getVDIRef().getVdiType() !== executionEnvironmentEnum.Citrix
                                    ) {
                                        var targetConstraints = stream.getVideoTracks()[0].getConstraints();

                                        if (targetConstraints) {
                                            targetConstraints.aspectRatio = '1.777777778';
                                        } else {
                                            targetConstraints = { aspectRatio: '1.777777778' };
                                        }
                                        stream.getVideoTracks()[0].applyConstraints(targetConstraints);
                                    }
                                }

                                deferred.resolve(deviceObj);
                            })
                            .catch(function (getStreamErr) {
                                var err = getStreamErr && getStreamErr.message ? getStreamErr.message : getStreamErr;

                                logger.error('generateDeviceObj', 'generateConstraints - getStream error', err);

                                service.setSfuDeviceError(mediaDeviceInfo.deviceId, err);

                                deferred.resolve(deviceObj);
                            });
                    } else {
                        //Audio Output
                        deferred.resolve(deviceObj);
                    }
                } else {
                    deferred.reject('Invalid mediaDeviceInfo');
                }
            } catch (err) {
                deferred.reject(err);
            }

            return deferred.promise;
        }

        function getIndexOfDeviceWithMatchingLabel(deviceLabelToCheck, deviceArray) {
            var deviceIndex = -1;

            //Example of matching Device Labels:
            //Device 1: USB Camera #1 (123a:4567)
            //Device 2: Default - USB Camera #1 (123a:4567)
            //Device 3: Communications - USB Camera #1 (123a:4567)

            if (!!deviceLabelToCheck && Array.isArray(deviceArray)) {
                for (var i = 0; i < deviceArray.length; i++) {
                    var enumeratedDevice = deviceArray[i];

                    if (enumeratedDevice && enumeratedDevice.label) {
                        var enumeratedDeviceLabelSubstring = enumeratedDevice.label
                            .replace('Default - ', '')
                            .replace('Communications - ', '');
                        var deviceLabelToCheckSubstring = deviceLabelToCheck
                            .replace('Default - ', '')
                            .replace('Communications - ', '');

                        if (enumeratedDeviceLabelSubstring === deviceLabelToCheckSubstring) {
                            deviceIndex = i;
                            break;
                        }
                    }
                }
            }

            return deviceIndex;
        }

        function isDeviceInUse(device) {
            if (!device) {
                return false;
            }

            var isInUse = false;

            switch (device.kind) {
                case 'audioinput':
                    isInUse = storageService.get('audio-device') === device.deviceId;
                    break;
                case 'audiooutput':
                    isInUse = storageService.get('audio-output-device') === device.deviceId;
                    break;
                case 'videoinput':
                    isInUse = storageService.get('video-device') === device.deviceId;
                    break;
            }

            return isInUse;
        }

        function addDeviceToArray(deviceToAdd, deviceArray) {
            if (!deviceToAdd || !deviceArray) {
                logService.log('Unable to add device to array due to invalid params');
                return;
            }

            if (meetingService.getDefaultOSDeviceEnabled() && deviceToAdd.deviceId === 'default') {
                deviceArray.push({
                    deviceId: deviceToAdd.deviceId,
                    groupId: deviceToAdd.groupId,
                    kind: deviceToAdd.kind,
                    label: localizationService.translate('HEADER.SETTINGS.USE_SYSTEM_SETTING'),
                    originalLabel: deviceToAdd.label
                });
                return;
            }

            //When a computer has connected devices, the OS sets one mic/webcam as 'default'
            //The enumerated device list will then contain two of the same device -- one will just have the deviceId of 'default'
            //We can safely ignore these as the other device in the list will have the true deviceId
            if (deviceToAdd.deviceId === 'default' || deviceToAdd.deviceId === 'communications') {
                switch (deviceToAdd.kind) {
                    case 'audioinput':
                        service.ignoredDevices.microphones[deviceToAdd.deviceId] = deviceToAdd;
                        break;
                    case 'audiooutput':
                        service.ignoredDevices.speakers[deviceToAdd.deviceId] = deviceToAdd;
                        break;
                    case 'videoinput':
                        service.ignoredDevices.webcams[deviceToAdd.deviceId] = deviceToAdd;
                        break;
                    default:
                        logService.log('Invalid device kind: ' + deviceToAdd.kind);
                        break;
                }

                return;
            }

            //If a device with matching label already exists in the array
            var indexOfMatchingDevice = service.getIndexOfDeviceWithMatchingLabel(deviceToAdd.label, deviceArray);
            if (indexOfMatchingDevice > -1) {
                //If the pending device is in use, we prioritize it
                //by removing the existing device and adding the pending device
                if (service.isDeviceInUse(deviceToAdd)) {
                    deviceArray.splice(indexOfMatchingDevice, 1);
                    deviceArray.push(deviceToAdd);
                }

                //Otherwise, we keep the existing device that is already in the array
                //And do not add the pending device
            } else {
                deviceArray.push(deviceToAdd);
            }
        }

        function openAudioContext() {
            var context;

            try {
                if ($window.AudioContext) {
                    context = new $window.AudioContext();
                } else if ($window.webkitAudioContext) {
                    context = new $window.webkitAudioContext();
                }

                if (context) {
                    service.audioContext = context;
                }
            } catch (err) {
                logService.log('Error creating audio context', err);
            }
        }

        function closeAudioContext() {
            //Ideally we want one AudioContext to track multiple audio sources
            //Only want to close it if both are true:
            //  1. All mic previews are closed (tracked via micLeveLIntervals)
            //  2. We have stopped tracking for locally cloned audio stream (tracked via localStreamManagerService)
            if (
                service.micLevelIntervals.length > 0 ||
                service.isAudioTrackActive(localStreamManagerService.clonedAudioStream)
            ) {
                return;
            }

            if (service.audioContext !== null) {
                service.audioContext.close();
                service.audioContext = null;
            }
        }

        function isAudioTrackActive(stream) {
            if (stream && stream.getAudioTracks) {
                var track = stream.getAudioTracks()[0];
                return track ? track.readyState === 'live' : false;
            }

            return false;
        }

        function createAudioAnalyser() {
            var analyser = null;

            if (service.audioContext) {
                analyser = service.audioContext.createAnalyser();
                analyser.smoothingTimeConstant = 0.3;
                analyser.fftSize = 1024;
            } else {
                logService.log('Unable to create audioAnalyser - invalid audioContext object');
            }

            return analyser;
        }

        function getAverageAudioVolume(array) {
            var values = 0;
            var average;

            var length = array.length;

            // get all the frequency amplitudes
            for (var i = 0; i < length; i++) {
                values += array[i];
            }

            average = values / length;
            return average;
        }

        function trackMicLevelForPreview(stream, cb) {
            var micLevelInterval = service.trackMicLevel(stream, cb);
            service.micLevelIntervals.push(micLevelInterval);
        }

        function trackMicLevel(stream, cb) {
            if (!helperService.getVDIRef().showAudioInputMicLevelIndicator) {
                return;
            }
            if (!service.audioContext) {
                service.openAudioContext();
            }

            try {
                var micSrc = service.audioContext.createMediaStreamSource(stream);
                var analyser = service.createAudioAnalyser();
                var bufferLength = analyser.frequencyBinCount;
                var dataArray = new Uint8Array(bufferLength);

                micSrc.connect(analyser);
                var micLevelInterval = $interval(function () {
                    analyser.getByteFrequencyData(dataArray);
                    var average = service.getAverageAudioVolume(dataArray);
                    var multiplier = average / 60;
                    var micLevel = 100 * (multiplier > 1 ? 1 : multiplier);

                    if (cb) {
                        cb(micLevel);
                    }
                }, 200);

                return micLevelInterval;
            } catch (e) {
                logService.log('Error tracking mic level:', e);
            }
        }

        function stopMicLevelTrackingForPreview() {
            service.closeAudioContext();

            service.micLevelIntervals.forEach(function (micLevelInterval, index, array) {
                $interval.cancel(micLevelInterval);

                //After final interval is canceled, clear array
                if (index === array.length - 1) {
                    service.micLevelIntervals = [];
                }
            });
        }

        function canTrackStartStopTalking(stream) {
            if (
                !stream ||
                meetingService.isWebinar() ||
                connectivityService.getAudioThroughPhone() ||
                !service.isAudioTrackActive(stream)
            ) {
                return false;
            }

            return true;
        }

        function trackStartStopTalking(stream, onStartTalkingCallback, onStopTalkingCallback) {
            if (!service.canTrackStartStopTalking(stream)) {
                return;
            }

            logService.log('avDeviceService.trackStartStopTalking - starting local audio tracking');

            stream.onStartTalkingCallback = onStartTalkingCallback;
            stream.onStopTalkingCallback = onStopTalkingCallback;

            if (!stream.localAudioInterval) {
                stream.localAudioInterval = service.trackMicLevel(stream, function (newMicLevel) {
                    // micLevel value can be 0-100

                    // represents hard sounds (words) when talking
                    var talkingThreshold = 30;

                    //Represents the audio levels that drop between words while speaking
                    var softThreshold = 12;

                    if (newMicLevel >= talkingThreshold) {
                        if (
                            stream.previousMicLevel < talkingThreshold &&
                            typeof stream.onStartTalkingCallback === 'function'
                        ) {
                            stream.onStartTalkingCallback();
                        }

                        service.cancelNotTalkingTimeout(stream);
                    } else if (newMicLevel < softThreshold) {
                        if (!stream.notTalkingTimeout) {
                            // if not talking for >0.5s
                            stream.notTalkingTimeout = $timeout(function () {
                                if (
                                    service.canTrackStartStopTalking(stream) &&
                                    typeof stream.onStopTalkingCallback === 'function'
                                ) {
                                    stream.onStopTalkingCallback();
                                }
                            }, 500); // 0.5 second
                        }
                    }

                    stream.previousMicLevel = newMicLevel;
                });
            }
        }

        function cancelNotTalkingTimeout(stream) {
            if (stream && stream.notTalkingTimeout) {
                $timeout.cancel(stream.notTalkingTimeout);
                stream.notTalkingTimeout = null;
            }
        }

        function untrackStartStopTalking(stream) {
            if (!stream) {
                return;
            }

            logService.log('avDeviceService.untrackStartStopTalking - stopping local audio tracking');

            service.cancelNotTalkingTimeout(stream);

            if (stream.localAudioInterval) {
                $interval.cancel(stream.localAudioInterval);
                stream.localAudioInterval = null;
                service.closeAudioContext();
            }

            stream.onStartTalkingCallback = null;
            stream.onStopTalkingCallback = null;
            stream.previousMicLevel = 0;
        }

        function getAudioOutputTestSource() {
            return $sce.trustAsResourceUrl(
                helperService.getLocationProtocol() +
                    '://www.' +
                    helperService.getLocationHost() +
                    '/webconference/sounds/speaker-test.wav'
            ); // 'Generic jazz wav'
        }

        function getActiveDevices() {
            var deferred = $q.defer();

            var activeDevices = {
                audioInput: null,
                videoInput: null,
                audioOutput: null
            };

            service
                .enumerateDevices()
                .then(function () {
                    if (devicePermissions.audioAllowed && !deviceErrors.micError) {
                        for (var i = 0; i < service.microphones.length; i++) {
                            if (service.microphones[i].deviceId === storageService.get('audio-device')) {
                                activeDevices.audioInput = service.microphones[i];
                                break;
                            }
                        }
                    }

                    if (devicePermissions.videoAllowed && !deviceErrors.camError) {
                        for (var j = 0; j < service.webcams.length; j++) {
                            if (service.webcams[j].deviceId === storageService.get('video-device')) {
                                activeDevices.videoInput = service.webcams[j];
                                break;
                            }
                        }
                    }

                    for (var k = 0; k < service.speakers.length; k++) {
                        if (service.speakers[k].deviceId === storageService.get('audio-output-device')) {
                            activeDevices.audioOutput = service.speakers[k];
                            break;
                        }
                    }

                    deferred.resolve(activeDevices);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function checkIfDeviceIsAvailable(mediaType, deviceId) {
            var deferred = $q.defer();
            var arrayName;
            var kind;

            switch (mediaType) {
                case service.deviceTypes.AUDIO_INPUT:
                    arrayName = 'microphones';
                    kind = 'audioinput';
                    break;
                case service.deviceTypes.AUDIO_OUTPUT:
                    arrayName = 'speakers';
                    kind = 'audiooutput';
                    break;
                case service.deviceTypes.VIDEO_INPUT:
                    arrayName = 'webcams';
                    kind = 'videoinput';
                    break;
            }

            if (!deviceId) {
                deferred.reject('Invalid deviceId:' + deviceId);
                return deferred.promise;
            }

            if (!arrayName) {
                deferred.reject('Invalid mediaType: ' + mediaType);
                return deferred.promise;
            }

            logService.log('Checking if ' + kind + ' device is available: ' + deviceId);
            service
                .enumerateDevices()
                .then(function () {
                    var arrayToCheck = service[arrayName];
                    for (var i = 0; i < arrayToCheck.length; i++) {
                        if (arrayToCheck[i].deviceId === deviceId && arrayToCheck[i].kind === kind) {
                            deferred.resolve(true);
                            return;
                        }
                    }

                    deferred.resolve(false);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getCurrentlySelectedMic() {
            var deviceId = storageService.get('audio-device');
            for (var i = 0; i < service.microphones.length; i++) {
                if (deviceId === service.microphones[i].deviceId) {
                    return service.microphones[i];
                }
            }

            return null;
        }

        function getCurrentlySelectedWebcam() {
            var deviceId = storageService.get('video-device');
            for (var i = 0; i < service.webcams.length; i++) {
                if (deviceId === service.webcams[i].deviceId) {
                    return service.webcams[i];
                }
            }

            return null;
        }

        function checkForBTHeadset() {
            if (!helperService.isWindows()) {
                return;
            }

            logService.log('checkForBTHeadset - Starting');

            //If BT Mic is active, only show BT Headset with matching groupId
            //Hide all other BT Output (even if they aren't the same physical device) -- these devices will not be able to output any sound

            var currentlySelectedMic = service.getCurrentlySelectedMic();
            var btMicGroupId;
            if (currentlySelectedMic && currentlySelectedMic.label.toLowerCase().indexOf('bluetooth') > -1) {
                btMicGroupId = currentlySelectedMic.groupId;
            }

            var matchingBTHeadsetIndex = service.speakers.findIndex(function (speaker) {
                return speaker.groupId === btMicGroupId;
            });

            //groupId is the only way we can guarantee that a BT Speaker is the same physical device as the BT Mic.
            //However, sometimes groupId does NOT match... in which case we should just return and not attempt to filter any BT Speakers.
            if (matchingBTHeadsetIndex === -1) {
                logService.log(
                    'checkForBTHeadset - Could not find headset with matching groupId... will not filter BT devices'
                );
                return;
            }

            if (btMicGroupId) {
                //Remove all other BT Headsets
                service.speakers = service.speakers.filter(function (speaker) {
                    return speaker.label.toLowerCase().indexOf('bluetooth') === -1 || speaker.groupId === btMicGroupId;
                });

                //If currentlySelectedSpeaker was removed from list, update to next available speaker
                var selectedSpeaker = service.speakers.find(function (speaker) {
                    return speaker.deviceId === storageService.get('audio-output-device');
                });

                if (!selectedSpeaker) {
                    //Ideally, fall back to matching headset
                    var matchingHeadset = service.speakers.find(function (speaker) {
                        return speaker.groupId === btMicGroupId;
                    });

                    var fallbackSpeaker = matchingHeadset || service.speakers[0];
                    if (fallbackSpeaker) {
                        logService.log(
                            'checkForBTHeadset - Updating audio output to default:',
                            fallbackSpeaker.deviceId
                        );
                        storageService.set('audio-output-device', fallbackSpeaker.deviceId);
                        $rootScope.$broadcast('update-audio-output');
                    }
                }
            }
        }

        function hasMicrophone() {
            return devicesAvailable.microphone;
        }

        function hasCamera() {
            return devicesAvailable.webcam;
        }

        function setHasMicrophone(hasMicrophoneParam) {
            devicesAvailable.microphone = hasMicrophoneParam ? true : false;
        }

        function setHasCamera(hasCameraParam) {
            devicesAvailable.webcam = hasCameraParam ? true : false;
        }

        function getDevicePermissions() {
            return devicePermissions;
        }

        function setDevicePermissions(newDevicePermissions, sendExtended) {
            var devicePermissionsChanged = false;

            if (newDevicePermissions) {
                if (
                    newDevicePermissions.audioAllowed !== undefined &&
                    newDevicePermissions.audioAllowed !== devicePermissions.audioAllowed
                ) {
                    devicePermissions.audioAllowed = newDevicePermissions.audioAllowed;
                    devicePermissionsChanged = true;
                }

                if (
                    newDevicePermissions.videoAllowed !== undefined &&
                    newDevicePermissions.videoAllowed !== devicePermissions.videoAllowed
                ) {
                    devicePermissions.videoAllowed = newDevicePermissions.videoAllowed;
                    devicePermissionsChanged = true;
                }
            }

            if (devicePermissionsChanged) {
                $rootScope.$broadcast('device-permissions-updated', { devicePermissions: devicePermissions });
                service.sendDevicePermissions(sendExtended);
            }
        }

        //TODO; maybe remove this flag and always send the full set
        function sendDevicePermissions(sendExtended) {
            var messageData;
            var devices = {};

            if (sendExtended) {
                try {
                    if (localStreamManagerService.currentLocalAudioTrack) {
                        devices.audioInputDevice = localStreamManagerService.currentLocalAudioTrack.label;
                    }

                    if (localStreamManagerService.currentLocalVideoTrack) {
                        devices.videoInputDevice = localStreamManagerService.currentLocalVideoTrack.label;
                    }
                } catch (err) {
                    logger.error('sendDevicePermissions', 'Error retrieving a/v track labels', err);
                }

                messageData = {
                    message: 'attendee-device-permissions-updated',
                    data: {
                        devicePermissions: service.getDevicePermissions(),
                        devices: devices,
                        saveDevicePermissionsToCDR: true,
                        hasMicrophone: service.hasMicrophone(),
                        hasCamera: service.hasCamera()
                    }
                };
            } else {
                messageData = {
                    message: 'attendee-device-permissions-updated',
                    data: { devicePermissions: service.getDevicePermissions() }
                };
            }

            socketService.send(messageData);
        }

        function getDeviceErrors() {
            return deviceErrors;
        }

        function setDeviceErrors(newDeviceErrors) {
            if (newDeviceErrors) {
                if (newDeviceErrors.camError !== undefined) {
                    deviceErrors.camError = newDeviceErrors.camError;
                    deviceErrors.camAdditional = '';
                    if (newDeviceErrors.camAdditional !== undefined) {
                        deviceErrors.camAdditional = newDeviceErrors.camAdditional;
                    }
                }

                if (newDeviceErrors.micError !== undefined) {
                    deviceErrors.micError = newDeviceErrors.micError;
                    deviceErrors.micAdditional = '';
                    if (newDeviceErrors.micAdditional !== undefined) {
                        deviceErrors.micAdditional = newDeviceErrors.micAdditional;
                    }
                }
            }
        }

        function setShouldIgnoreCamera(newIgnoreCamera) {
            ignoreCamera = newIgnoreCamera;
        }

        function shouldIgnoreCamera() {
            return ignoreCamera;
        }

        function startDevicePermissionsFlow(opts) {
            return service
                .checkIfAVDevicePermissionsGranted()
                .catch(function (err) {
                    logService.log('startDevicePermissionsFlow Unable to check if AV Device permissions granted:', err);
                    return;
                })
                .then(function () {
                    //If at least one of audio or video device permissions not already granted,
                    //call startWebrtcPromptOverlay which will trigger device permissions prompt
                    if (service.audioOrVideoBlocked()) {
                        return service
                            .startWebrtcPromptOverlay(opts)
                            .catch(function (err) {
                                logger.error('startDevicePermissionsFlow', 'error in startWebrtcPromptOverlay', err);
                            })
                            .then(function () {
                                if (helperService.getChromeVersion() >= 81) {
                                    logService.log(
                                        'startDevicePermissionsFlow Chrome 81+ detected... checking mic and cam availability'
                                    );
                                    return service.determineMicAndCamAvailability(true).catch(function (err) {
                                        logger.error(
                                            'startDevicePermissionsFlow',
                                            'error in determineMicAndCamAvailability',
                                            err
                                        );
                                    });
                                }
                            });
                    }
                });
        }

        function audioOrVideoBlocked() {
            var devicePermissions = service.getDevicePermissions();
            return !devicePermissions.audioAllowed || !devicePermissions.videoAllowed;
        }

        // show the webrtc permissions prompt by invoking
        // getUserMedia. This returns a promise.
        function startWebrtcPromptOverlay(opts) {
            var deferred = $q.defer();

            if (helperService.isElectron()) {
                deferred.resolve();
                return deferred.promise;
            }

            // this will show the built-in prompt
            service
                .getStream({ audio: service.hasMicrophone(), video: service.hasCamera() })
                .then(function (stream) {
                    logService.log('avDeviceService startWebrtcPromptOverlay successful');
                    service.cancelDevicePermissionPrompt();

                    var audioTracks = stream.getAudioTracks();
                    if (audioTracks && audioTracks.length > 0) {
                        service.setDevicePermissions({ audioAllowed: true });
                    }

                    var videoTracks = stream.getVideoTracks();
                    if (videoTracks && videoTracks.length > 0) {
                        service.setDevicePermissions({ videoAllowed: true });
                    }

                    stream.getTracks().forEach(function (track) {
                        try {
                            track.stop();
                        } catch (err) {}
                    });
                    deferred.resolve();
                })
                .catch(function (err) {
                    logService.log('avDeviceService startWebrtcPromptOverlay error: ' + err);
                    deferred.reject(err);

                    service.cancelDevicePermissionPrompt();
                    if (connectivityService.getIsInDeviceSelectionFlow()) {
                        return;
                    }
                    service.showBlockedPermissionsBanner();

                    if (!opts || !opts.avSettingsModal) {
                        $timeout(function () {
                            service.showBlockedAlert();
                        }, 500);
                    }
                });

            service.showDevicePermissionPromptWithDelay(1000);
            return deferred.promise;
        }

        // following functions were moved from conferenceCtrl to avDeviceService

        function requestSystemPermissionForDevices() {
            var deferred = $q.defer();
            var systemMicrophonePermissionAllowed = true;
            var systemCameraPermissionAllowed = true;

            if (
                meetingService.getIsSfuEnabled() &&
                (helperService.isChromeOSXCatalina() || helperService.isWindows())
            ) {
                var ms = 3000;

                var getUserMediaTimeout;

                var timeoutPromise = $q(function (resolve) {
                    getUserMediaTimeout = $timeout(resolve, ms);
                }).then(function () {
                    if (getUserMediaTimeout !== null) {
                        throw new Error('getUserMedia calls did not resolve within ' + ms + ' seconds.');
                    }
                });

                // Check audio
                var audioPromise = $window.navigator.mediaDevices
                    .getUserMedia({ audio: true })
                    .then(function (stream) {
                        stream.getTracks().forEach(function (track) {
                            try {
                                track.stop();
                            } catch (err) {}
                        });
                    })
                    .catch(function (err) {
                        if (err && err.message === 'Permission denied by system') {
                            systemMicrophonePermissionAllowed = false;
                        }
                    });

                // Check video
                var videoPromise = $window.navigator.mediaDevices
                    .getUserMedia({ video: true })
                    .then(function (stream) {
                        stream.getTracks().forEach(function (track) {
                            try {
                                track.stop();
                            } catch (err) {}
                        });
                    })
                    .catch(function (err) {
                        if (err && err.message === 'Permission denied by system') {
                            systemCameraPermissionAllowed = false;
                        }
                    });

                var allPromise = $q.allSettled([audioPromise, videoPromise]).catch(angular.noop);

                $q.race([timeoutPromise, allPromise])
                    .then(function (value) {
                        logger.log('requestSystemPermissionForDevices', 'Permissions:', value);
                    })
                    .catch(function (err) {
                        logger.error('requestSystemPermissionForDevices', 'Error', err);
                    })
                    .finally(function () {
                        deferred.resolve({
                            audioAllowed: systemMicrophonePermissionAllowed,
                            videoAllowed: systemCameraPermissionAllowed
                        });

                        // Cleanup promises and timers
                        $timeout.cancel(getUserMediaTimeout);
                        getUserMediaTimeout = null;
                        timeoutPromise = null;
                        audioPromise = null;
                        videoPromise = null;
                        allPromise = null;
                    });
            } else if (helperService.isMac() && helperService.isElectron()) {
                Promise.all([
                    $window.preloadedApi.systemPreferences.askForMediaAccess('microphone'),
                    $window.preloadedApi.systemPreferences.askForMediaAccess('camera')
                ])
                    .then(([micAllowed, cameraAllowed]) => {
                        deferred.resolve({
                            audioAllowed: micAllowed,
                            videoAllowed: cameraAllowed
                        });
                    })
                    .catch(err => {
                        logger.error(
                            'requestSystemPermissionForDevices',
                            'error acquiring systemPreferences from electron object',
                            err
                        );

                        deferred.resolve({
                            audioAllowed: systemMicrophonePermissionAllowed,
                            videoAllowed: systemCameraPermissionAllowed
                        });
                    });
            } else {
                deferred.resolve({
                    audioAllowed: systemMicrophonePermissionAllowed,
                    videoAllowed: systemCameraPermissionAllowed
                });
            }

            return deferred.promise;
        }

        function checkIfAVDevicePermissionsGranted() {
            var deferred = $q.defer();
            var mediaDevices = helperService.getMediaDevices();

            logService.log('Checking if AV device permissions are granted');

            //Devices with allowed permissions will have a label property
            if (mediaDevices && mediaDevices.enumerateDevices) {
                mediaDevices
                    .enumerateDevices()
                    .then(function (devices) {
                        var allowedMicFound = false;
                        var allowedWebcamFound = false;

                        // Loop through all devices to find an audio device and a video device that
                        // have device labels (an empty label means the device is blocked by the browser)
                        for (var i = 0; i < devices.length; i++) {
                            if (devices[i].label !== '') {
                                if (devices[i].kind === 'audioinput' && !allowedMicFound) {
                                    allowedMicFound = true;
                                } else if (devices[i].kind === 'videoinput' && !allowedWebcamFound) {
                                    allowedWebcamFound = true;
                                }
                            }

                            if (allowedMicFound && allowedWebcamFound) {
                                break;
                            }
                        }

                        logService.log(
                            'Audio device permissions initial state:',
                            allowedMicFound ? 'granted' : 'not granted'
                        );
                        logService.log(
                            'Video device permissions initial state:',
                            allowedWebcamFound ? 'granted' : 'not granted'
                        );

                        service
                            .requestSystemPermissionForDevices()
                            .then(function (permissions) {
                                macOSSystemPermissions.audioAllowed = permissions.audioAllowed;
                                macOSSystemPermissions.videoAllowed = permissions.videoAllowed;

                                service.setDevicePermissions({
                                    audioAllowed: allowedMicFound && permissions.audioAllowed
                                });
                                service.setDevicePermissions({
                                    videoAllowed: allowedWebcamFound && permissions.videoAllowed
                                });
                                deferred.resolve();
                            })
                            .catch(function (err) {
                                logService.log('requestSystemPermissionForDevices error:', err);
                                service.setDevicePermissions({ audioAllowed: allowedMicFound });
                                service.setDevicePermissions({ videoAllowed: allowedWebcamFound });
                                deferred.resolve();
                            });
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
            } else {
                deferred.reject('enumerateDevices not available');
            }

            return deferred.promise;
        }

        function getMacOSSystemPermissions() {
            return macOSSystemPermissions;
        }

        function showBlockedPermissionsBanner() {
            var supportLink;
            var header = '';
            var content = '';

            if (helperService.isChrome()) {
                supportLink = supportLinkService.getSupportLink('allowMicChrome');
            } else if (helperService.isElectron() && helperService.isMac()) {
                supportLink = supportLinkService.getSupportLink('catalinaScreenShare');
            }
            content =
                supportLink !== 'base_url_not_available' && !helperService.isVideoRoomApplication()
                    ? localizationService.translate('HEADER.NO_PERMISSION_TO_YOUR_MIC_OR_WEBCAM_WITH_URL_TO_FIX', {
                          link: supportLink
                      })
                    : localizationService.translate('HEADER.NO_PERMISSION_TO_YOUR_MIC_OR_WEBCAM');
            $rootScope.$broadcast('banner-message-show', { header: header, content: content, persist: true });
        }

        function showBlockedAlert() {
            var permissions = service.getDevicePermissions();
            var alertTitle;
            var alertText;

            if (!permissions.audioAllowed) {
                alertTitle = permissions.videoAllowed
                    ? localizationService.translate('HEADER.DIALOG.MICROPHONE_BLOCKED')
                    : localizationService.translate('HEADER.DIALOG.CAMERA_AND_MICROPHONE_BLOCKED');

                alertText = permissions.videoAllowed
                    ? localizationService.translate('HEADER.DIALOG.MICROPHONE_BLOCKED_MESSAGE')
                    : localizationService.translate('HEADER.DIALOG.CAMERA_AND_MICROPHONE_BLOCKED_MESSAGE');
            } else if (!permissions.videoAllowed) {
                alertText = localizationService.translate('HEADER.DIALOG.CAMERA_BLOCKED_MESSAGE');
                alertTitle = localizationService.translate('HEADER.DIALOG.CAMERA_BLOCKED');
            } else {
                //This case can happen if permissions are allowed on Chrome, but blocked at OS level
                //in which case, another alert will be triggered elsewhere
                logger.warn('showBlockedAlert', 'called but no devices are blocked');
                return;
            }

            var okBtn = localizationService.translate('COMMON.OK_FIX_IT');
            var cancelBtn = localizationService.translate('COMMON.CANCEL_GOT_IT');

            if (helperService.getDevicePlatform() === 'iOS') {
                helperService.mobileConfirm(alertText, alertTitle, alertCallback, [okBtn, cancelBtn].join(','));
            } else {
                if (helperService.getIsRedesign() === true) {
                    var closeButtonHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal(
                        {
                            title: closeButtonHtml + alertTitle,
                            text: '<b>' + alertText + '</b>',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonText: okBtn,
                            confirmButtonColor: brandingService.getBaseColor(),
                            closeOnConfirm: false,
                            cancelButtonText: cancelBtn,
                            allowOutsideClick: false,
                            html: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                        },
                        alertCallback
                    );
                } else {
                    //TODO: REMOVE POST-REDESIGN
                    $window.swal(
                        {
                            title: alertTitle,
                            text: '<b>' + alertText + '</b>',
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonText: okBtn,
                            confirmButtonColor: brandingService.getBaseColor(),
                            closeOnConfirm: false,
                            cancelButtonText: cancelBtn,
                            allowOutsideClick: false,
                            html: true
                        },
                        alertCallback
                    );
                }
            }

            function alertCallback(userResponse) {
                var fixIt = false;

                if (helperService.getDevicePlatform() === 'iOS') {
                    //1 = Yes
                    //2 = No
                    fixIt = userResponse === 1;
                } else {
                    fixIt = userResponse ? true : false;
                }

                if (fixIt) {
                    var supportLink = '';

                    if (helperService.isChrome()) {
                        supportLink = supportLinkService.getSupportLink('allowMicChrome');
                    } else if (helperService.isMobile()) {
                        supportLink = supportLinkService.getSupportLink('micCamMobile');
                    }

                    meetingService.openExternalLink(supportLink);
                }
            }
        }
        function cancelDevicePermissionPrompt() {
            if (devicePermissionPromptTimeout !== null) {
                $timeout.cancel(devicePermissionPromptTimeout);
                devicePermissionPromptTimeout = null;
                $window.swal.close();
                service.setIsPermissionOverlayOpen(false);
            }
        }

        function showDevicePermissionPromptWithDelay(delay) {
            devicePermissionPromptTimeout = $timeout(function () {
                $window.swal({
                    title: localizationService.translate('HEADER.DIALOG.SHARE_MIC_AND_WEBCAM'),
                    type: 'warning',
                    allowOutsideClick: false,
                    closeOnCancel: false,
                    closeOnConfirm: false,
                    customClass: 'initial-webrtc',
                    html: true
                });

                service.setIsPermissionOverlayOpen(true);

                $window.$('.popover').popover('hide');
            }, delay);
        }

        function determineMicAndCamAvailability(initialCheck, deviceChanged) {
            var hasSpeaker = false,
                storedVideo = storageService.get('video-device'),
                storedAudio = storageService.get('audio-device'),
                storedAudioOut = storageService.get('audio-output-device'),
                foundStoredVideo = false,
                foundStoredAudio = false,
                foundStoredAudioOut = false,
                defaultVideo = null,
                defaultAudio = null,
                defaultAudioOut = null;

            var ecAudioOut = storageService.get('explicitly-chosen-audio-output-device'),
                ecAudioIn = storageService.get('explicitly-chosen-audio-input-device'),
                ecVideoIn = storageService.get('explicitly-chosen-video-input-device'),
                foundECAudioOut = false,
                foundECAudioIn = false,
                foundECVideoIn = false;

            //Intended to store the raw device object
            var ecAudioOutObj, ecAudioInObj, ecVideoInObj;

            let tmpDefaultAudioInputObj, tmpDefaultAudioOutputObj;

            var deferred = $q.defer();

            // When we init the service, we pull devices from the cookie and set in the local properies ... these
            // are then chosen in the call flow.  But first we iterate through the devices and make sure they exist.  if they
            // don't, then we use the first non-default device we found when iterating through devices
            //
            // If 'explicitly chosen' devices are available, we prioritize those above the rest
            const oldHasCamera = service.hasCamera();

            service
                .enumerateDevices()
                .then(function () {
                    logService.log('in enumerateDevices');

                    //By now, mic/webcam/speakers arrays will already have ignored 'communications' and 'default' devices
                    //But we still want to prioritize these physical devices, just with their actual GUID deviceId...

                    for (var i = 0; i < service.microphones.length; i++) {
                        if (
                            service.ignoredDevices.microphones.default &&
                            service.ignoredDevices.microphones.default.groupId === service.microphones[i].groupId
                        ) {
                            //Prioritize 'default' device first
                            defaultAudio = service.microphones[i].deviceId;
                        } else if (
                            !defaultAudio &&
                            !meetingService.getDefaultOSDeviceEnabled() &&
                            service.ignoredDevices.microphones.communications &&
                            service.ignoredDevices.microphones.communications.groupId === service.microphones[i].groupId
                        ) {
                            //Prioritize 'communications' device second
                            defaultAudio = service.microphones[i].deviceId;
                        }

                        //If 'default' or 'communications' not found, default to first available device
                        if (service.microphones.length - 1 === i && !defaultAudio) {
                            defaultAudio = service.microphones[0].deviceId;
                        }

                        if (service.microphones[i].deviceId && service.microphones[i].deviceId === storedAudio) {
                            foundStoredAudio = true;
                        }

                        if (service.microphones[i].deviceId && service.microphones[i].deviceId === ecAudioIn) {
                            foundECAudioIn = true;

                            if (deviceChanged) {
                                ecAudioInObj = service.microphones[i];
                            }
                        }

                        if (
                            meetingService.getDefaultOSDeviceEnabled() &&
                            service.microphones[i].deviceId === 'default'
                        ) {
                            tmpDefaultAudioInputObj = service.microphones[i];
                        }
                    }

                    for (var j = 0; j < service.webcams.length; j++) {
                        if (helperService.getDevicePlatform() === 'iOS' && service.webcams[j].label === 'Back Camera') {
                            logService.log('Skipping Back Camera...');
                            continue;
                        }

                        if (
                            service.ignoredDevices.webcams.default &&
                            service.ignoredDevices.webcams.default.groupId === service.webcams[j].groupId
                        ) {
                            //Prioritize 'default' device first
                            defaultVideo = service.webcams[j].deviceId;
                        } else if (
                            !defaultVideo &&
                            !meetingService.getDefaultOSDeviceEnabled() &&
                            service.ignoredDevices.webcams.communications &&
                            service.ignoredDevices.webcams.communications.groupId === service.webcams[j].groupId
                        ) {
                            //Prioritize 'communications' device second
                            defaultVideo = service.webcams[j].deviceId;
                        }

                        //If 'default' or 'communications' not found, default to first available device
                        if (service.webcams.length - 1 === j && !defaultVideo) {
                            defaultVideo = service.webcams[0].deviceId;
                        }

                        if (service.webcams[j].deviceId && service.webcams[j].deviceId === storedVideo) {
                            foundStoredVideo = true;
                        }

                        if (service.webcams[j].deviceId && service.webcams[j].deviceId === ecVideoIn) {
                            foundECVideoIn = true;

                            if (deviceChanged) {
                                ecVideoInObj = service.webcams[j];
                            }
                        }
                    }

                    for (var k = 0; k < service.speakers.length; k++) {
                        //As we iterate through all speakers, prioritize 'default' first, 'communications' second
                        if (service.speakers[k].deviceId === 'default') {
                            //Prioritize 'default' device first
                            defaultAudioOut = service.speakers[k].deviceId;
                        } else if (
                            !defaultAudioOut &&
                            service.ignoredDevices.speakers.communications &&
                            service.ignoredDevices.speakers.communications.groupId === service.speakers[k].groupId
                        ) {
                            //Prioritize 'communications' device second
                            defaultAudioOut = service.speakers[k].deviceId;
                        }

                        //If 'default' or 'communications' not found, default to first available device
                        if (service.speakers.length - 1 === k && !defaultAudioOut) {
                            defaultAudioOut = service.speakers[0].deviceId;
                        }

                        if (service.speakers[k].deviceId && service.speakers[k].deviceId === storedAudioOut) {
                            foundStoredAudioOut = true;
                        }

                        if (service.speakers[k].deviceId && service.speakers[k].deviceId === ecAudioOut) {
                            foundECAudioOut = true;

                            if (deviceChanged) {
                                ecAudioOutObj = service.speakers[k];
                            }
                        }

                        hasSpeaker = true;

                        if (meetingService.getDefaultOSDeviceEnabled() && service.speakers[k].deviceId === 'default') {
                            tmpDefaultAudioOutputObj = service.speakers[k];
                        }
                    }

                    if (deviceChanged) {
                        const newHasCamera = service.hasCamera();

                        // the only webcam was unplugged or plugged in
                        if (oldHasCamera === false && newHasCamera === true) {
                            service.setIsNewVideoDeviceConnected(true);
                        } else if (oldHasCamera === true && newHasCamera === false) {
                            service.setIsNewVideoDeviceConnected(false);
                        }

                        $rootScope.$broadcast('device-change-detected');

                        //Active speaker was disconnected
                        if (!foundStoredAudioOut) {
                            if (defaultAudioOut) {
                                logService.log(
                                    'enumerateDevices: active speaker was disconnected... falling back to: ' +
                                        defaultAudioOut
                                );
                                storageService.set('audio-output-device', defaultAudioOut);
                                $rootScope.$broadcast('update-audio-output');
                            } else {
                                logService.log(
                                    'enumerateDevices: active speaker was disconnected, but no fallback device available'
                                );
                            }
                        }

                        var shouldShowGrowl = false;

                        if (
                            !connectivityService.getAudioThroughPhone() &&
                            storedAudio === 'default' &&
                            tmpDefaultAudioInputObj &&
                            service.defaultAudioInputObj &&
                            tmpDefaultAudioInputObj.originalLabel !== service.defaultAudioInputObj.originalLabel
                        ) {
                            logService.log('Default Audio Input Changed');
                            localStreamManagerService.stopLocalAudioTrack();
                            service.untrackStartStopTalking(localStreamManagerService.clonedAudioStream);
                            localStreamManagerService.stopClonedAudioStream();

                            $rootScope.$broadcast('finished-media-device-selection', {
                                newAudioInputDeviceSelected: true
                            });

                            shouldShowGrowl = true;
                        }

                        if (
                            storedAudioOut === 'default' &&
                            tmpDefaultAudioOutputObj &&
                            service.defaultAudioOutputObj &&
                            tmpDefaultAudioOutputObj.originalLabel !== service.defaultAudioOutputObj.originalLabel
                        ) {
                            logService.log('Default Audio Output Changed');
                            shouldShowGrowl = true;
                        }

                        if (shouldShowGrowl) {
                            notificationService.show(
                                localizationService.translate('NOTIFICATIONS.MEETING_DEVICE_CHANGED_TO_MATCH_OS'),
                                'success'
                            );
                        }

                        if (service.getIsPendingDeviceReconnect()) {
                            logService.log(
                                'enumerateDevices: User pending device reconnection...  will not prompt for explicitly chosen devices'
                            );
                        } else {
                            var ecDevicesChanged = {};

                            if (foundECAudioOut && storedAudioOut !== ecAudioOut) {
                                logService.log('enumerateDevices: explicitly-chosen audio output device connected');
                                ecDevicesChanged.audioOutput = ecAudioOutObj;
                            }

                            if (foundECAudioIn && storedAudio !== ecAudioIn) {
                                logService.log('enumerateDevices: explicitly-chosen audio input device connected');
                                ecDevicesChanged.audioInput = ecAudioInObj;
                            }

                            if (foundECVideoIn && storedVideo !== ecVideoIn) {
                                logService.log('enumerateDevices: explicitly-chosen video input device connected');
                                ecDevicesChanged.videoInput = ecVideoInObj;
                            }

                            if (Object.keys(ecDevicesChanged).length > 0) {
                                service.promptForExplicitlyChosenDevices(ecDevicesChanged);
                            }
                        }
                    } else {
                        if (service.hasMicrophone()) {
                            if (initialCheck && foundECAudioIn) {
                                logService.log(
                                    'enumerateDevices: using explicitly chosen audio input device:',
                                    ecAudioIn
                                );
                                storageService.set('audio-device', ecAudioIn);
                            } else if (foundStoredAudio) {
                                logService.log('enumerateDevices: using stored audio device', storedAudio);
                            } else if (defaultAudio) {
                                logService.log('enumerateDevices: setting default audio device', defaultAudio);
                                storageService.set('audio-device', defaultAudio);
                            } else {
                                logService.log('enumerateDevices: audio device found, but no device id available');
                            }
                        }

                        if (service.hasCamera()) {
                            if (initialCheck && foundECVideoIn) {
                                logService.log(
                                    'enumerateDevices: using explicitly chosen video input device:',
                                    ecVideoIn
                                );
                                storageService.set('video-device', ecVideoIn);
                            } else if (foundStoredVideo) {
                                logService.log('enumerateDevices: using stored video device', storedVideo);
                            } else if (defaultVideo) {
                                logService.log('enumerateDevices: setting default video device', defaultVideo);
                                storageService.set('video-device', defaultVideo);
                            } else {
                                logService.log('enumerateDevices: video device found, but no device id available');
                            }
                        }

                        if (hasSpeaker) {
                            if (initialCheck && foundECAudioOut) {
                                logService.log(
                                    'enumerateDevices: using explicitly chosen audio output device:',
                                    ecAudioOut
                                );
                                storageService.set('audio-output-device', ecAudioOut);
                            } else if (foundStoredAudioOut) {
                                logService.log('enumerateDevices: using stored audio output device', storedAudioOut);
                            } else if (defaultAudioOut) {
                                logService.log(
                                    'enumerateDevices: setting default audio output device',
                                    defaultAudioOut
                                );
                                storageService.set('audio-output-device', defaultAudioOut);
                            } else {
                                logService.log(
                                    'enumerateDevices: audio output device found, but no device id available'
                                );
                            }
                        }
                    }

                    if (tmpDefaultAudioInputObj) {
                        service.defaultAudioInputObj = tmpDefaultAudioInputObj;
                    }

                    if (tmpDefaultAudioOutputObj) {
                        service.defaultAudioOutputObj = tmpDefaultAudioOutputObj;
                    }

                    if (initialCheck) {
                        logService.log(
                            'enumerateDevices: Initial device check - microphone found: ' + service.hasMicrophone()
                        );
                        logService.log('enumerateDevices: Initial device check - webcam found: ' + service.hasCamera());
                        logService.log('enumerateDevices: Initial device check - speaker found: ' + hasSpeaker);
                    }

                    deferred.resolve();
                })
                .catch(function (err) {
                    logger.error('determineMicAndCamAvailability', 'error in enumerateDevices', err);

                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getIsNewVideoDeviceConnected() {
            return newVideoDeviceConnected;
        }

        function setIsNewVideoDeviceConnected(newValue) {
            newVideoDeviceConnected = newValue;
        }

        function hasMicrophoneDeviceError() {
            return (
                connectivityService.getConferenceConnected() &&
                (!service.getDevicePermissions().audioAllowed || service.isMicrophoneHavingAnIssue()) &&
                !connectivityService.getAudioThroughPhone() &&
                service.hasMicrophone()
            );
        }

        function isMicrophoneHavingAnIssue() {
            if (helperService.getDevicePlatform() === 'iOS') {
                return !service.getDevicePermissions().audioAllowed;
            }

            //We intentionally end the audio track if switched-to-phone
            if (connectivityService.getAudioThroughPhone()) {
                return false;
            }

            if (service.getIsMicrophoneDeviceSwitching()) {
                return false;
            }

            if (
                service.getSfuDeviceErrorFromId(storageService.get('audio-device')) &&
                !localStreamManagerService.isLocalAudioTrackActive()
            ) {
                return true;
            }

            return service.getDevicePermissions().audioAllowed && !localStreamManagerService.isLocalAudioTrackActive();
        }

        function isAudioDeviceBlocked() {
            var permissions = service.getDevicePermissions();
            return service.hasMicrophone() && permissions && !permissions.audioAllowed;
        }

        function hasWebcamDeviceError() {
            return (
                (service.isVideoDeviceBlocked() &&
                    service.hasCamera() &&
                    connectivityService.getConferenceConnected()) ||
                service.isWebcamHavingAnIssue()
            );
        }

        function isWebcamHavingAnIssue() {
            return !!service.getSfuDeviceErrorFromId(storageService.get('video-device'));
        }

        function isVideoDeviceBlocked() {
            var permissions = service.getDevicePermissions();
            return service.hasCamera() && permissions && !permissions.videoAllowed;
        }

        function setIsMicrophoneDeviceSwitching(newMicrophoneDeviceSwitching) {
            logService.log('setIsMicrophoneDeviceSwitching ...');
            microphoneDeviceSwitching = newMicrophoneDeviceSwitching;
        }

        function getIsMicrophoneDeviceSwitching() {
            return microphoneDeviceSwitching;
        }

        function initDeviceChangeListener() {
            if ($window.navigator && $window.navigator.mediaDevices) {
                if (!$window.navigator.mediaDevices.ondevicechange) {
                    logService.log('Initializing ondevicechange listener');
                    $window.navigator.mediaDevices.ondevicechange = service.onDeviceChange;
                } else {
                    logService.log('ondevicechange already initialized');
                }
            } else {
                logger.warn(
                    'initDeviceChangeListener',
                    'Invalid mediaDevices... unable to init ondevicechange listener'
                );
            }
        }

        function removeDeviceChangeListener() {
            if ($window.navigator.mediaDevices.ondevicechange) {
                logService.log('Removing ondevicechange listener');
                $window.navigator.mediaDevices.ondevicechange = undefined;
            }
        }

        function onDeviceChange() {
            //This event does not contain any detail about which devices were added/removed...
            //So we need to call enumerateDevices (via determineMicAndCamAvailability) to determine the device changes

            //In some cases a single physical device will have a mic AND webcam, or mic AND speaker, etc.
            //This will trigger multiple events usually within a couple hundred miliseconds of each other (hence the 250ms timeout)
            if (!self.handlingOnDeviceChanged) {
                logService.log('onDeviceChange...');
                self.handlingOnDeviceChanged = true;

                if (helperService.getVDIRef().handleDetachedTrackOnDeviceChange) {
                    service.handleDetachedDeviceTrackOnVDI();
                }

                //We want enumerateDevices to be called after the timeout because it multiple devices are unplugged at once,
                //It will return the latest/most accurate list of devices
                $timeout(function () {
                    self.handlingOnDeviceChanged = false;

                    if (connectivityService.getIsInDeviceSelectionFlow()) {
                        $rootScope.$broadcast('device-changed-during-device-preview');
                    } else {
                        service.determineMicAndCamAvailability(false, true);
                    }
                }, 250);

                $timeout(function () {
                    if (
                        (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix ||
                            helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.VMware) &&
                        !attendeeService.getIsVideoMuted() &&
                        !attendeeService.getIsVideoActive()
                    ) {
                        // VDI - Fallback to internal webcam if active webcam device is detached.
                        $rootScope.$broadcast(
                            'active-track-ended',
                            localStreamManagerService.getCurrentWebcamStreamForVDI().getTracks()[0]
                        );
                    }
                }, 2000);
            }
        }

        function promptForExplicitlyChosenDevices(devices) {
            if (!devices || (!devices.audioInput && !devices.audioOutput && !devices.videoInput)) {
                logService.log('Returning from promptForExplicitlyChosenDevices due to invalid params');
                return;
            }

            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';

            var text = '';

            if (devices.audioInput) {
                text += '<br/>' + localizationService.translate('COMMON.MICROPHONE') + ': ' + devices.audioInput.label;
            }

            if (devices.audioOutput) {
                text += '<br/>' + localizationService.translate('COMMON.SPEAKER') + ': ' + devices.audioOutput.label;
            }

            if (devices.videoInput) {
                text += '<br/>' + localizationService.translate('COMMON.WEBCAM') + ': ' + devices.videoInput.label;
            }

            text +=
                '<br/><br/><span class="bold">' +
                localizationService.translate('HEADER.DIALOG.NEW_DEVICES_DETECTED_TEXT') +
                '</span>';

            logService.log('Prompting user to switch to explicitly-chosen devices');

            $window.swal(
                {
                    title: closeButtonHtml + localizationService.translate('HEADER.DIALOG.NEW_DEVICES_DETECTED_TITLE'),
                    text: text,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    closeOnConfirm: true,
                    cancelButtonText: localizationService.translate('COMMON.NO_TEXT'),
                    allowOutsideClick: false,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                },
                function (switchToECD) {
                    if (switchToECD) {
                        logService.log('User chose to switch to explicitly-chosen devices');

                        if (devices.audioInput) {
                            storageService.set('audio-device', devices.audioInput.deviceId);
                        }

                        if (devices.audioOutput) {
                            storageService.set('audio-output-device', devices.audioOutput.deviceId);
                        }

                        if (devices.videoInput) {
                            storageService.set('video-device', devices.videoInput.deviceId);
                        }

                        //This will restart the Janus media with updated devices
                        $rootScope.$broadcast('finished-media-device-selection', {
                            newVideoInputDeviceSelected: !!devices.videoInput,
                            newAudioInputDeviceSelected: !!devices.audioInput,
                            newAudioOutputDeviceSelected: !!devices.audioOutput
                        });
                        if (
                            helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix ||
                            helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.VMware
                        ) {
                            service.switchToSelectedAudioInputOnVdi();
                        }
                    } else {
                        logService.log('User chose not to switch to explicitly-chosen devices');
                    }
                }
            );
        }

        function setIsPendingDeviceReconnect(newPendingDeviceReconnect) {
            pendingDeviceReconnect = newPendingDeviceReconnect;
        }

        function getIsPendingDeviceReconnect() {
            return pendingDeviceReconnect;
        }

        function setSfuDeviceError(deviceId, errorName) {
            logService.log('setSfuDeviceError ... ' + deviceId + ' ' + errorName);
            if (!deviceId) {
                logService.log('avDeviceService - unable to set device error - invalid deviceId');
                return;
            }

            if (!errorName) {
                errorName = 'Unknown Error';
            }

            logService.log('avDeviceService - setting device error - ' + deviceId + ' - ' + errorName);
            sfuDeviceErrors[deviceId] = errorName;
        }

        function clearSfuDeviceError(deviceId) {
            if (!deviceId) {
                logService.log('avDeviceService - unable to clear device error - invalid deviceId');
            }

            if (sfuDeviceErrors[deviceId]) {
                logService.log('avDeviceService - clearing device error - ' + deviceId);
                delete sfuDeviceErrors[deviceId];
            } else {
                logService.log(
                    'avDeviceService - unable to clear device error - error does not exist in deviceErrors obj'
                );
            }
        }

        function getSfuDeviceErrorFromId(deviceId) {
            if (sfuDeviceErrors && sfuDeviceErrors[deviceId]) {
                return sfuDeviceErrors[deviceId];
            } else {
                return null;
            }
        }

        function getSfuDeviceErrors() {
            return sfuDeviceErrors;
        }

        function openMicCamPermissionTroubleShootPage() {
            var kbArticle = supportLinkService.getSupportLink('allowMicChrome');
            $window.open(kbArticle, '_blank');
        }

        function openMicCamPermissionTroubleShootPageForElectron() {
            var kbArticle = supportLinkService.getSupportLink('catalinaScreenShare');
            $window.open(kbArticle, '_blank');
        }

        function openCameraSystemPreference() {
            macSecurityPreferencesService.openCamera();
        }

        function openMicrophoneSystemPreference() {
            macSecurityPreferencesService.openMicrophone();
        }

        function setIsPermissionOverlayOpen(newVal) {
            isPermissionOverlayOpen = newVal;
        }

        function getIsPermissionOverlayOpen() {
            return isPermissionOverlayOpen;
        }

        function isAudioDisconnected() {
            return audioDisconnected;
        }

        function setAudioDisconnected(disconnected) {
            audioDisconnected = disconnected;
            var msg = {};
            msg.message = 'audio-disconnect-state-update';
            msg.data = audioDisconnected;
            socketService.send(msg);
        }

        function toggleMuteAudioInputAndOutput() {
            service.setAudioDisconnected(!audioDisconnected);
            storageService.set(
                'disconnected-audio',
                JSON.stringify({ disconnected: audioDisconnected, meetingCode: meetingService.getMeetingCode() })
            );
            connectivityService.disconnectAudioInputAndOutput(audioDisconnected);
        }

        function handleDetachedDeviceTrackOnVDI() {
            let disconnectedMic = service.getCurrentlySelectedMic()?.label;
            service
                .getActiveDevices()
                .then(function (activeDevices) {
                    var activeAudioInput =
                        activeDevices && activeDevices.audioInput ? activeDevices.audioInput.label : '';
                    if (!activeAudioInput && disconnectedMic !== undefined) {
                        storageService.set('audio-device', 'default');
                        let fallbackMic = service.getCurrentlySelectedMic()?.label;
                        if (fallbackMic === undefined) {
                            fallbackMic = localizationService.translate('HEADER.SETTINGS.USE_SYSTEM_SETTING');
                        }
                        $window.swal({
                            title: localizationService.translate('HEADER.DIALOG.ACTIVE_MIC_SWITCH_TITLE'),
                            text: localizationService.translate('HEADER.DIALOG.ACTIVE_MIC_SWITCH_MESSAGE', {
                                disconnectedMic,
                                fallbackMic
                            }),
                            type: 'warning',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            html: true
                        });
                    }
                })
                .catch(function (err) {
                    logger.error('handleDetachedDeviceTrackOnVDI', 'Unable to retrieve active devices', err);
                });
        }

        function switchToSelectedAudioInputOnVdi() {
            let audioOnlyConstraints = service.generateConstraints('audio', storageService.get('audio-device'));
            service
                .getStream(audioOnlyConstraints)
                .then(function (audioOnlyStream) {
                    logService.log('avDeviceService - Successully retrieved audio-only stream after device switch');
                })
                .catch(function (audioOnlyStreamRetrievalError) {
                    logService.log(
                        'avDeviceService - Error retrieving audio-only stream after device switch',
                        audioOnlyStreamRetrievalError
                    );
                });
        }

        function getAllPhysicalMicDevices() {
            return service.microphones.filter(microphone => microphone.deviceId !== 'default');
        }
    }
]);
